module.exports = __webpack_public_path__ + "static/toppharm-b0f86db32fee45a6699757fe2ca444dd.png";